import React from 'react';
export const RenderIf: React.FC<{ condition: boolean | undefined | null }> = ({ condition, children }) => {
  return condition ? <>{children}</> : null;
};
